import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { teacher } from '../model/teacher';
@Injectable({
  providedIn: 'root'
})
@Injectable({
  providedIn: 'root'
})
export class ParentsService {
  readonly APIUrl = "https://api.stnhd.com/api/"
  //readonly APIUrl = "https://localhost:44301/api/"

  constructor(private http: HttpClient) { }
  getAll(): Observable<any> {
    return this.http.get<any[]>(this.APIUrl + "Parents/getAllParent");
  }
  createParents(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Parents/CreateParents", model);
  }
  delParents(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Parents/delParents", model);
  }
  editParents(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Parents/EditParents", model);
  }
}
